"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-console */
var imageConstants_1 = require("./utils/imageConstants");
var react_1 = __importDefault(require("react"));
var react_lazyload_1 = __importDefault(require("react-lazyload"));
var styled_components_1 = __importStar(require("styled-components"));
var url_1 = __importDefault(require("url"));
var Loader_1 = __importDefault(require("./Loader"));
var Image = function (props) {
    var alt = props.alt, className = props.className, _a = props.crop, crop = _a === void 0 ? false : _a, disableLazyLoad = props.disableLazyLoad, onClick = props.onClick, onError = props.onError, onLoad = props.onLoad, getImageHost = props.getImageHost, _b = props.loader, Loader = _b === void 0 ? Loader_1.default : _b, noSrcModification = props.noSrcModification, missingAssetPath = props.missingAssetPath, _c = props.resizeable, resizeable = _c === void 0 ? true : _c, sizes = props.sizes, _d = props.src, src = _d === void 0 ? "missing.png" : _d;
    if (!sizes) {
        // eslint-disable-next-line max-len
        console.warn('Warning: no "sizes" prop detected on <Image /> component. The "sizes" property will be required in the next major version of @goat/web-common');
    }
    var getImagePathname = function (_a) {
        var pathname = _a.pathname, forceCrop = _a.forceCrop, _b = _a.size, size = _b === void 0 ? imageConstants_1.DEFAULT_IMAGE_SIZE : _b;
        if (/missing.png/.test(pathname)) {
            return "/placeholders/dash.png";
        }
        return (pathname
            // create the pathnameSegment array containing each path item
            // /750/path/to/image.jpg -> ['', '750', 'path', 'to', 'image.jpg']
            .split("/")
            // iterate over each pathnameSegment to create paths
            // with the correct size and crop for src/srcSet
            .reduce(function (urlSegments, pathnameSegment, index) {
            // throw out empty pathnameSegments or segments with an image size
            // srcSet uses all allowed sizes so the size should come from the 'size' func param
            var isSizeInstruction = index <= 2 &&
                imageConstants_1.ALLOWED_SIZES.includes(parseInt(pathnameSegment, 10));
            var forceCropOverridesUrlCrop = forceCrop && pathnameSegment === "crop";
            if (!pathnameSegment ||
                isSizeInstruction ||
                forceCropOverridesUrlCrop) {
                return urlSegments;
            }
            // pathnames can get 'crop' at the beginning if it was already in the url or
            // if the user passes in the crop variable. We initialize urlSegments w/ crop
            // if the user has passed it in. This block checks for cropping in the original url
            if (!forceCrop && pathnameSegment === "crop") {
                return __spreadArrays(["crop"], urlSegments);
            }
            // all other items will appear in the constructed path
            return __spreadArrays(urlSegments, [pathnameSegment]);
        }, [forceCrop && "crop", size])
            // forceCrop and splitting the pathname can result in falsey urlSegments
            // these need to be filtered out
            .filter(function (segment) { return !!segment; })
            // join and return the urlSegments
            .join("/"));
    };
    /** Flag that determines if no asset image is present. */
    var isMissing = /missing.png/.test(src || '');
    /**
     * Creates the source props used by <Image />
     *
     * @returns {{ src: string, srcSet: string }} src props spread on <StyledImage />
     */
    var getImageSrcs = function () {
        if (noSrcModification) {
            return { src: src };
        }
        var url = url_1.default.parse(src || "missing.png");
        url.protocol = "https"; // request all images with https
        if (typeof getImageHost === 'function') {
            url.host = getImageHost(url.host); // get correct CDN host if applicable
        }
        // non-resizeable images are routed to the correct CDN
        // without changing the crop or size
        if (!resizeable) {
            return {
                src: url_1.default.format(url)
            };
        }
        // src is a backup for browsers without srcset
        // its path is updated with the crop prop and default size
        var originalPathname = url.pathname;
        if (originalPathname) {
            url.pathname = getImagePathname({
                pathname: originalPathname,
                forceCrop: crop
            });
        }
        // srcSet lets the browser pick the best size from ALLOWED_SIZES
        var imageSrcs = {
            src: url_1.default.format(url),
            srcSet: imageConstants_1.ALLOWED_SIZES.map(function (sizeNum) {
                if (originalPathname) {
                    url.pathname = getImagePathname({
                        pathname: originalPathname,
                        forceCrop: crop,
                        size: sizeNum
                    });
                }
                return url_1.default.format(url) + " " + sizeNum + "w";
            }).join(", ")
        };
        // Custom image src and srcset object if no actual asset to display.
        // It sets src as a 1x1 transparent image.
        var missingSrcs = {
            src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
            srcSet: ""
        };
        return (isMissing && missingAssetPath) ? missingSrcs : imageSrcs;
    };
    var imageSrcs = getImageSrcs();
    var ImageLoader = Loader ? (react_1.default.createElement(Image.LoaderWrapper, null,
        react_1.default.createElement(Loader, null))) : null;
    var baseImage = (react_1.default.createElement(Image.StyledImage, __assign({}, props, { alt: alt, className: className, onClick: onClick, onError: onError, onLoad: onLoad, sizes: sizes }, imageSrcs, { missingAssetPath: missingAssetPath, isMissing: isMissing })));
    if (disableLazyLoad) {
        return baseImage;
    }
    return (react_1.default.createElement(react_lazyload_1.default, { once: true, placeholder: ImageLoader }, baseImage));
};
// images use objectFit contain
// to support responsive / client sizes
// that differ from the delivered image
Image.StyledImage = styled_components_1.default.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  // Sets a centered missing asset as background if product image is missing\n  ", "\n"], ["\n  width: 100%;\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  // Sets a centered missing asset as background if product image is missing\n  ",
    "\n"])), function (_a) {
    var missingAssetPath = _a.missingAssetPath, isMissing = _a.isMissing;
    if (missingAssetPath && isMissing) {
        return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        background: url(", ") no-repeat center; \n      "], ["\n        background: url(", ") no-repeat center; \n      "])), missingAssetPath);
    }
});
Image.LoaderWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
exports.default = Image;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Image.js.map